<p-dialog
  [header]="headerTitle()"
  [(visible)]="visible"
  [modal]="true"
  [maximizable]="true"
  [draggable]="false"
  [resizable]="false"
  [style]="{ width: '90vw', height: '85vh' }"
  [breakpoints]="{ '1300px': '95vw', '768px': '95vw', '480px': '95vw' }"
  #diag
  [styleClass]="getDialogStyleClass()"
  [maximizable]="true"
  [closable]="false"
  (onMaximize)="maximized.set($event.maximized)"
  (onHide)="onHide()"
  [contentStyle]="{
    padding: '0',
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  }">
  <ng-template pTemplate="header">
    <div
      class="dialog-header px-4 pt-1 flex justify-content-between w-full align-items-center"
      style="margin-right: 2rem">
      <div class="dialog-header-left flex align-items-center gap-2">
        <span class="dialog-header-number">#{{ ticket()?.ticket_number_teorema }}</span>
        <p-button
          icon="pi pi-copy"
          [rounded]="true"
          [text]="true"
          severity="secondary"
          (onClick)="copyMenu.toggle($event)"
          styleClass="p-0 ml-1 w-2rem h-2rem" />
        <p-menu
          #copyMenu
          [popup]="true"
          [model]="copyMenuItems"
          appendTo="body"
          styleClass="ticket-copy-menu" />
        @if (ticket(); as t) {
          @if (t.created_at) {
            <p-tag [value]="formatDateShort(t.created_at)" severity="secondary" [rounded]="true" />
          }
          <p-tag
            [value]="getSituationDescription(t.situation)"
            [severity]="getSituationSeverity(t.situation)"
            [rounded]="true" />
          @if (t.urgent) {
            <p-tag value="Urgente" severity="danger" [rounded]="true" />
          }
          @if (t.status) {
            <p-tag
              [value]="t.status.description"
              [severity]="getStatusSeverity(t.status.description)"
              [rounded]="true" />
          }
          @for (tt of t.ticket_tags; track tt.id) {
            <p-tag [value]="tt.tag.name" severity="info" [rounded]="true" />
          }
          @if (t.responsible) {
            <p-tag
              [value]="t.responsible.name"
              severity="secondary"
              icon="pi pi-user"
              [rounded]="true"
              [pTooltip]="'Responsável'"
              tooltipPosition="bottom" />
          }
          @if (activeLogs().length > 0) {
            <span class="active-log-badge flex">
              <i class="pi pi-spin pi-clock"></i>
              <span>
                @for (log of activeLogs(); track log.id; let isLast = $last) {
                  <span>{{ log.user?.name ?? 'Usuário' }}</span>
                  @if (!isLast) {
                    <span>,&nbsp;</span>
                  }
                }
                apontando
              </span>
            </span>
          }
        }
      </div>
    </div>
    <div class="p-dialog-header-icons flex align-items-center" style="margin-right: 0.5rem">
      <app-ticket-ai-analysis
        [ticket]="ticket()"
        buttonClass="p-button-sm p-0 w-2rem h-2rem text-color-secondary"
        (saved)="refreshAfterAi()" />
      <p-button
        icon="pi pi-window-maximize"
        [rounded]="true"
        [text]="true"
        severity="secondary"
        [pTooltip]="'Abrir em nova aba'"
        tooltipPosition="bottom"
        (onClick)="openInNewTab()"
        styleClass="p-button-sm p-0 w-2rem h-2rem text-color-secondary">
      </p-button>

      <!-- Botão Maximizar Customizado com Tooltip -->
      <p-button
        [icon]="maximized() ? 'bi bi-fullscreen-exit' : 'bi bi-arrows-fullscreen'"
        [rounded]="true"
        [text]="true"
        severity="secondary"
        [pTooltip]="maximized() ? 'Restaurar' : 'Expandir'"
        tooltipPosition="bottom"
        (onClick)="diag.maximize()"
        styleClass="p-button-sm p-0 w-2rem h-2rem text-color-secondary">
      </p-button>

      <!-- Botão Fechar Customizado com Tooltip -->
      <p-button
        icon="pi pi-times"
        [rounded]="true"
        [text]="true"
        severity="secondary"
        [pTooltip]="'Fechar'"
        tooltipPosition="bottom"
        (onClick)="onHide()"
        styleClass="p-button-sm p-0 w-2rem h-2rem text-color-secondary">
      </p-button>
    </div>
  </ng-template>

  @if (loading()) {
    <div class="modal-body" [style.grid-template-columns]="gridColumns()">
      <div class="col-left">
        <div class="skeleton-pad">
          @for (_ of [1, 2, 3, 4, 5, 6, 7, 8]; track $index) {
            <p-skeleton height="1.5rem" styleClass="mb-3" />
          }
        </div>
      </div>
      <div class="col-center">
        <div class="skeleton-pad">
          <p-skeleton height="3rem" styleClass="mb-3" />
          <p-skeleton height="6rem" styleClass="mb-3" />
          <p-skeleton height="4rem" />
        </div>
      </div>
      <div class="col-right">
        <div class="skeleton-pad">
          @for (_ of [1, 2, 3, 4]; track $index) {
            <div class="timeline-skeleton-item">
              <p-skeleton shape="circle" size="2.5rem" />
              <div class="flex-1">
                <p-skeleton height="1rem" width="40%" styleClass="mb-2" />
                <p-skeleton height="2rem" />
              </div>
            </div>
          }
        </div>
      </div>
    </div>
  } @else if (ticket(); as t) {
    <div class="modal-body" [style.grid-template-columns]="gridColumns()">
      <!-- Coluna esquerda: info compacta + campos editáveis -->
      <div class="col-left">
        <app-ticket-info-panel
          [ticket]="t"
          [canEdit]="canEdit()"
          (ticketUpdated)="onTicketUpdated($event)"
          (bulkEditModeChanged)="onBulkEditModeChanged($event)" />
      </div>

      <!-- Coluna central: accordion com seções -->
      <div class="col-center">
        <div class="col-center-scroll">
          <p-accordion
            [multiple]="true"
            [value]="accordionValue()"
            (valueChange)="onAccordionChange($event)">
            <!-- Resumo -->
            @if (t.summary) {
              <p-accordion-panel value="0">
                <p-accordion-header>
                  <span class="accordion-header">
                    <i class="pi pi-file-edit"></i>
                    <span>Resumo</span>
                  </span>
                </p-accordion-header>
                <p-accordion-content>
                  <div class="content-text">
                    <markdown [data]="t.summary || ''"></markdown>
                  </div>
                </p-accordion-content>
              </p-accordion-panel>
            }

            <!-- Problema -->
            @if (t.problem) {
              <p-accordion-panel value="1">
                <p-accordion-header>
                  <span class="accordion-header">
                    <i class="pi pi-exclamation-triangle"></i>
                    <span>Problema</span>
                  </span>
                </p-accordion-header>
                <p-accordion-content>
                  <div class="content-text">
                    <markdown class="ticket-problem-markdown" [data]="t.problem || ''"></markdown>
                  </div>
                </p-accordion-content>
              </p-accordion-panel>
            }

            <!-- Anexos -->
            <p-accordion-panel value="2">
              <p-accordion-header>
                <span class="accordion-header">
                  <i class="pi pi-paperclip"></i>
                  <span>Anexos ({{ sortedDocuments().length || 0 }})</span>
                </span>
              </p-accordion-header>
              <p-accordion-content>
                <app-ticket-attachments
                  [documents]="sortedDocuments()"
                  [ticketId]="ticket()?.id || ''"
                  [currentUserId]="currentUserId()"
                  (attachmentDeleted)="onAttachmentDeleted()" />
              </p-accordion-content>
            </p-accordion-panel>

            <!-- Documentações -->
            <p-accordion-panel value="3">
              <p-accordion-header>
                <span class="accordion-header">
                  <i class="pi pi-book"></i>
                  <span>Documentações ({{ (t.documentations || []).length }})</span>
                </span>
              </p-accordion-header>
              <p-accordion-content>
                <app-ticket-documentations
                  [ticketId]="t.id"
                  [initialDocumentations]="t.documentations || []"
                  (documentationsUpdated)="onDocumentationsUpdated($event)" />
              </p-accordion-content>
            </p-accordion-panel>

            <!-- Tarefas -->
            <p-accordion-panel value="4">
              <p-accordion-header>
                <span class="accordion-header">
                  <i class="pi pi-check-square"></i>
                  <span>Tarefas ({{ t.tasks.length || 0 }})</span>
                </span>
              </p-accordion-header>
              <p-accordion-content>
                <app-ticket-tasks
                  [ticket]="t"
                  [canEdit]="true"
                  [focusTaskId]="focusTaskId"
                  (tasksUpdated)="onTasksUpdated($event)"
                  (ticketRefreshRequired)="onTicketRefreshRequired($event)"
                  (startTimeEntry)="onTaskStartTimeEntry($event)" />
              </p-accordion-content>
            </p-accordion-panel>

            <!-- Desenvolvimento -->
            @if (isDevCanRead()) {
              <p-accordion-panel value="5">
                <p-accordion-header>
                  <span class="accordion-header">
                    <i class="pi pi-code"></i>
                    <span>Desenvolvimento</span>
                  </span>
                </p-accordion-header>
                <p-accordion-content>
                  <app-ticket-development
                    [ticketId]="t.id"
                    [canWrite]="isDevCanWrite()"
                    [requirementsVersion]="devRequirementsVersion()"
                    [revisionsVersion]="devRevisionsVersion()"
                    (ticketRefreshRequired)="onDevelopmentRefreshRequired($event)"
                    (developmentUpdated)="onDevelopmentUpdated($any($event))" />
                </p-accordion-content>
              </p-accordion-panel>
            }

            <!-- Qualidade -->
            @if (isQualityCanRead()) {
              <p-accordion-panel value="6">
                <p-accordion-header>
                  <span class="accordion-header">
                    <i class="pi pi-list-check"></i>
                    <span>Qualidade ({{ qualityCount() }})</span>
                  </span>
                </p-accordion-header>
                <p-accordion-content>
                  <app-ticket-quality
                    [ticketId]="t.id"
                    [canWrite]="isQualityCanWrite()"
                    (publicationsUpdated)="qualityCount.set($event.length)" />
                </p-accordion-content>
              </p-accordion-panel>
            }
          </p-accordion>
        </div>
      </div>

      <!-- Alça de redimensionamento -->
      <div
        class="resizer-handle"
        (mousedown)="onResizeStart($event)"
        (dblclick)="resetResize()"
        [pTooltip]="'Duplo clique para restaurar o tamanho'"
        tooltipPosition="top">
        <div class="resizer-line"></div>
      </div>

      <!-- Coluna direita: timeline -->
      <div class="col-right">
        <div class="col-right-scroll">
          <app-ticket-timeline
            [entries]="timelineEntries()"
            [highlightedEntryId]="highlightedEntryId()" />
        </div>
      </div>

      <!-- Action bar ocupa centro + direita -->
      <app-ticket-action-bar
        class="action-bar-span"
        [ticket]="t"
        [canEdit]="canEdit()"
        (commentAdded)="onCommentAdded($event)"
        (timeEntryAdded)="onTimeEntryAdded($event)"
        (attachmentAdded)="onAttachmentAdded($event)"
        [bulkEditMode]="bulkEditModeActive"
        (bulkEditModeChange)="onBulkEditModeToggled($event)">
      </app-ticket-action-bar>
    </div>

    <!-- Task Management Modal -->
    @if (ticket(); as currentTicket) {
      <app-task-management-modal
        [ticket]="currentTicket"
        [canEdit]="canEdit()"
        [(visible)]="showTaskModal"
        (tasksUpdated)="onTasksUpdated($event)"
        (ticketRefreshRequired)="onTicketRefreshRequired($event)"
        (startTimeEntry)="onTaskStartTimeEntry($event)" />
    }
  }
</p-dialog>

<!-- Canal ticket-{uuid}: pilha ÚNICA (mesma chave), mais recente sempre no topo — formando um
     histórico único de tudo que aconteceu com o chamado, em vez de duas pilhas sem relação
     visual entre si. Atividade indireta (apontamento/comentário/anexo/tarefa) é só informativa;
     alteração DIRETA de campos do chamado ganha um botão "Atualizar" (equivalente ao antigo
     "Sim" do modal) — ignorar/fechar equivale ao antigo "Não". Quando uma nova alteração direta
     chega, o toast amarelo anterior é fechado e um novo (com tudo agregado) sobe ao topo. -->
<p-toast
  key="ticket-activity"
  position="top-right"
  styleClass="ticket-activity-toast"
  (onClose)="onActivityToastClose($event)">
  <ng-template let-message pTemplate="message">
    <div class="ticket-activity-toast__body">
      <i class="ticket-activity-toast__icon" [ngClass]="message.icon || 'pi pi-bell'"></i>
      <div class="ticket-activity-toast__content">
        <span class="ticket-activity-toast__title">{{ message.summary }}</span>
        @if (message.detail) {
          <span class="ticket-activity-toast__detail">{{ message.detail }}</span>
        }
        @if (message.data?.onAction) {
          <div class="ticket-activity-toast__actions">
            <button
              type="button"
              class="ticket-activity-toast__action"
              (click)="onActivityToastActionClick(message.data)">
              <i class="pi pi-refresh"></i>
              @if (message.data.changes?.length > 1) {
                Atualizar tudo ({{ message.data.changes.length }})
              } @else {
                Atualizar tela
              }
            </button>
            <span class="ticket-activity-toast__shortcut-hint">
              ou <kbd>Ctrl</kbd><kbd>.</kbd>
            </span>
          </div>
        }
      </div>
    </div>
  </ng-template>
</p-toast>

<!-- Automações do chamado: modal de sugestão pós-save (status → tipo, etc.).
     Fora do p-dialog de propósito — sobrevive a um reload do chamado, que é justamente quando
     o refresh 'full' de uma tarefa avalia a automação.
     Duplicado em `pages/ticket-detail/ticket-detail.component.html`. -->
<app-ticket-automation-confirm
  scope="ticket-detail"
  [ticketId]="ticket()?.id"
  (applyStarted)="onAutomationApplyStarted()"
  (applied)="onAutomationApplied($event)" />
